import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RouterLink, RouterOutlet} from '@angular/router';
import {NgClass, NgOptimizedImage} from "@angular/common";
import {OneQuestion} from "@white-label/components/page-builder/models/faq.model";
export interface CommonQuestionsModel {
    opened: boolean,
    question: string,
    answer: string
}
@Component({
  selector: 'white-label-faq-item',
  standalone: true,
    imports: [
        RouterOutlet,
        RouterLink,
        NgOptimizedImage,
        NgClass
    ],
  templateUrl: './faq-item.component.html'
})
export class FaqItemComponent {
    @Input() question?: any;
    @Output() closeAll = new EventEmitter();

    toggle(){
        this.closeAll.emit(this.question);
    }
}
